<template>
  <div style="height: 100%">
    <div class="actionBtn">
      <el-button type="primary" @click="levelGo(0)"
        ><el-icon> <plus /> </el-icon><span>新增</span></el-button
      >
    </div>
    <el-dialog v-model="dialogFormVisible" :title="title">
      <el-form :model="formState" :rules="rules">
        <el-form-item
          label="中文名："
          :label-width="formLabelWidth"
          prop="level_name_ch"
        >
          <el-input
            v-model="formState.level_name_ch"
            placeholder="客户级别中文名"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="英文名："
          prop="level_name_en"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formState.level_name_en"
            placeholder="客户级别英文名"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="级别码："
          prop="level_code"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formState.level_code"
            placeholder="客户级别码"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态：" :label-width="formLabelWidth">
          <el-switch
            v-model="formState.level_status"
            class="ml-2"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
          />
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="formState.level_remark" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="add">{{ goTitle }}</el-button>
        </span>
      </template>
    </el-dialog>
    <div class="content">
      <el-table
        :data="dataSource"
        style="width: 100%; font-size: 12px"
        height="100%"
        stripe:true
      >
        <el-table-column
          fixed
          prop="level_id"
          label="ID"
          width="100"
          sortable
        />
        <el-table-column
          prop="level_name_ch"
          label="中文名"
          width="200"
          fixed
        />
        <el-table-column prop="level_name_en" label="英文名" width="200" />
        <el-table-column prop="level_code" label="级别码" width="200" />
        <el-table-column prop="level_status" label="状态" width="120">
          <template #default="scope">
            <span
              :style="{
                color: scope.row.level_status == 1 ? 'green' : 'red',
              }"
            >
              {{ scope.row.level_status == 1 ? "开启" : "关闭" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="level_remark" label="备注" width="200" />
        <el-table-column fixed="right" label="操作" width="200">
          <template #default="scope">
            <el-button type="primary" @click="levelGo(scope.row)">
              <el-icon> <edit /> </el-icon><span>编辑</span></el-button
            >
            <el-button type="danger" @click="del(scope.row.level_id)"
              ><el-icon> <delete /> </el-icon><span>删除</span></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="demo-pagination-block">
        <el-pagination
          :currentPage="currentPage"
          :page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :background="true"
          layout="sizes, prev, pager, next, jumper,total"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import {
  customerLevelList,
  customerLevelAdd,
  customerLevelDel,
} from "@/network/basic.js";
import { Delete, Edit, Plus, Search } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  components: {
    Delete,
    Edit,
    Plus,
    Search,
  },
  setup() {
    const currentPage = ref(1);
    const pageSize = ref(10);
    const pageTotal = ref(0);
    const state = reactive({
      dataSource: [],
      title: "添加客户级别",
      goTitle: "添加",
      dialogFormVisible: false,
      formLabelWidth: "140px",
    });
    const rules = reactive({
      level_name_en: [
        {
          required: true,
          message: "请输入客户级别英文名",
          trigger: "blur",
        },
      ],
      level_name_ch: [
        {
          required: true,
          message: "请输入客户级别中文名",
          trigger: "blur",
        },
      ],
      level_code: [
        {
          required: true,
          message: "请输入客户级别码",
          trigger: "blur",
        },
      ],
    });
    const formState = reactive({
      level_id: 0,
      level_name_en: "",
      level_name_ch: "",
      level_code: "",
      level_status: 1,
      level_remark: "",
    });
    const getList = () => {
      customerLevelList({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
      }).then((res) => {
        if (res.code == 0) {
          state.dataSource = res.data.lists;
          pageTotal.value = res.data.pageTotal;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleSizeChange = (val) => {
      pageSize.value = val;
      getList();
    };
    const handleCurrentChange = (val) => {
      currentPage.value = val;
      getList();
    };
    onMounted(() => {
      getList();
    });
    //------------以上为列表数据

    const levelGo = (row) => {
      state.dialogFormVisible = true;
      if (row) {
        Object.assign(formState, row);
        state.goTitle = "更新";
        state.title = "修改客户级别信息";
        formState.level_status = Boolean(row.level_status);
      } else {
        state.goTitle = "添加";
        state.title = "添加客户级别";
        formState.level_id = 0;
        formState.level_name_en = "";
        formState.level_name_ch = "";
        formState.level_code = "";
        formState.level_status = true;
        formState.level_remark = "";
      }
    };
    const add = () => {
      if (!formState.level_name_ch) {
        ElMessage.info("请填写客户级别名称");
        return false;
      }
      customerLevelAdd(formState).then((res) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          state.dialogFormVisible = false;
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    //------------以上为编辑和修改数据
    const del = (level_id) => {
      if (!level_id) {
        ElMessage("所选数据为空，请重新选择！");
      } else {
        ElMessageBox.confirm("确定要删除该条数据吗?", "警告", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            customerLevelDel({ level_id: level_id }).then((res) => {
              if (res.code == 0) {
                ElMessage.success(res.msg);
                getList();
              } else {
                ElMessage.error(res.msg);
              }
            });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "删除取消",
            });
          });
      }
    };

    return {
      ...toRefs(state),
      rules,
      formState,
      levelGo,
      add,
      del,
      currentPage,
      pageSize,
      pageTotal,
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>
<style scoped>
.el-select :deep .select-popper {
  z-index: 8888 !important;
  top: auto !important;
  left: auto !important;
}
.actionBtn {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.content {
  height: calc(100% - 180px);
  position: relative;
}
.el-table {
  position: absolute;
}
.el-table__header {
  width: 100%;
}
.el-table__body {
  height: calc(100% - 40px);
}
.el-pagination {
  position: absolute;
  bottom: -56px;
  right: 20px;
}
</style>
